import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-su_030",
  "use": "icon-su_030-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-su_030\"><defs><style>#icon-su_030 .cls-1{fill:none;opacity:0;}#icon-su_030 .cls-2{fill:#5ab3a0;}</style></defs><g id=\"icon-su_030_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-su_030_icon\"><rect class=\"cls-1\" width=\"20\" height=\"20\" /><polygon class=\"cls-2\" points=\"8.5 16.12 2.94 10.56 5.06 8.44 8.5 11.88 15.44 4.94 17.56 7.06 8.5 16.12\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol